import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MuiButtonModule } from '../button';
import { MuiIconModule } from '../icon';
import { MuiBanner } from './mui-banner.component';


@NgModule({
  declarations: [
    MuiBanner
  ],
  exports: [
    MuiBanner
  ],
  imports: [
    CommonModule,
    MuiButtonModule,
    MuiIconModule
  ]
})
export class MuiBannerModule {}
